'use client'

import { AlertTriangle, Info } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

import { getQueryClient, TAG_TYPES } from '~/lib/config'
import { Button } from '~/modules/common/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '~/modules/common/components/ui/tooltip'

const queryClient = getQueryClient()
export default function Error({
  error,
  reset,
}: {
  error: APIError
  reset: () => void
}) {
  const t = useTranslations('common.boundary')
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  const handleRetry = async () => {
    Object.values(TAG_TYPES)
      .map(el => [el])
      .map((el) => {
        return queryClient.refetchQueries({
          queryKey: el,
        })
      })
    // await queryClient.invalidateQueries({
    //   queryKey: Object.values(TAG_TYPES).filter((type) => type === 'AUTH')
    // });
    reset()
  }

  return (
    <div className="relative size-full flex items-center justify-center h-full">
      <div className="relative z-10 flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-lg min-h-[200px] min-w-[350px]">
        <AlertTriangle className="size-16 text-red-600 mb-4 animate-pulse" />
        <h2 className="text-2xl font-semibold text-gray-800 mb-2 animate-fade-in">
          {t('error')}
        </h2>
        <div className="flex items-center mb-4 text-gray-600 text-center space-x-2">
          <p className=" flex gap-1 items-center">
            <TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger>
                  <Info className="size-5 text-gray-400 hover:text-gray-600 cursor-pointer" />
                </TooltipTrigger>
                <TooltipContent
                  onPointerDownOutside={(event) => {
                    event.preventDefault()
                  }}
                  className="bg-secondary text-textcolor border-primary border-2"
                >
                  <p>{t('moreInformation')}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <span>{error?.error?.message || t('apiError')}</span>
          </p>
        </div>
        <Button
          variant="default"
          className="px-6 py-2 bg-primary text-primary-foreground rounded-lg shadow-md hover:bg-primary/70 transition duration-300 ease-in-out animate-fade-in flex items-center hover:scale-105"
          onClick={handleRetry}
        >
          {t('tryAgain')}
        </Button>
      </div>
    </div>
  )
}
